import styled from 'styled-components';
import { ReactComponent as Logout } from 'styles/icons/logout.svg';
import { ReactComponent as Notification } from 'styles/icons/notification.svg';
import { normalize } from 'utils/styles';
import { color, media, typography } from 'styles/settings';
import { animated } from 'react-spring';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  position: fixed;
  top: ${normalize('150px')};
  right: ${normalize('15px')};
  background-color: ${color.neutral.white};
  height: ${normalize('20px')};
  padding: ${normalize('20px')} 0;
  padding-left: ${normalize('24px')};
  padding-right: ${normalize('20px')};
  z-index: 2;
`;

export const LabelsHolder = styled.div`
  display: flex;
  flex-direction: column;
  ${media.mediaQueries.mobile`
    display:none;
  `}
`;

export const LabelHolder = styled(animated.div)``;

export const Label = styled(animated.span)`
  ${typography.font.semiBold};
  font-size: ${normalize('14px')};
  line-height: ${normalize('20px')};
  color: ${color.neutral.black};
`;

export const HiddenLabel = styled.span`
  ${typography.font.semiBold};
  font-size: ${normalize('14px')};
  line-height: ${normalize('20px')};
  color: ${color.neutral.black};
  height: 0;
  visibility: hidden;
`;

export const LogoutIcon = styled(Logout)`
  color: ${color.brand.blueDark};
  margin-left: ${normalize('24px')};
  cursor: pointer;
  :hover {
    color: ${color.brand.gold};
  }
  :active {
    color: ${color.brand.blueDark};
  }
`;

export const Separator = styled.div`
  margin-left: ${normalize('25px')};
  margin-right: ${normalize('25px')};
  background-color: #cfcfcf;
  height: ${normalize('36px')};
  width: ${normalize('1px')};
`;
